import type { LiabilityFormLayout } from "../types";

export const alreadyAmortizedLayout = (): LiabilityFormLayout => {
  return {
    render: 'alreadyAmortized'
  }
}
